import { NgModule } from '@angular/core';
import { PhoneComponent } from '~shared/svgs/phone/phone.component';


@NgModule({
  declarations: [
    PhoneComponent
  ],
  exports: [
    PhoneComponent
  ]
})
export class PhoneModule {}
